import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/logos/logos-logo-up.png'


_pushScopeId("data-v-2282909c")
const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_2 = [
  _hoisted_1
]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LocaleChange = _resolveComponent("LocaleChange")!
  const _component_BaseNavbar = _resolveComponent("BaseNavbar")!

  return (_openBlock(), _createBlock(_component_BaseNavbar, { name: "main-navbar-top" }, {
    "navbar-logo": _withCtx(() => [
      _createElementVNode("div", {
        class: "navbar-item is-clickable",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.goHome && $setup.goHome(...args)))
      }, _hoisted_2)
    ]),
    "navbar-items-right": _withCtx(() => [
      _createVNode(_component_LocaleChange)
    ]),
    _: 1
  }))
}